import { useState, useEffect, createContext, useContext } from 'react';
import api from '@/lib/api';
import { AWARDS, TESTIMONIALS, COMPANY_INFO } from '@/lib/constants';

const CMSContext = createContext(null);

export function CMSProvider({ children }) {
  const [awards, setAwards] = useState(AWARDS);
  const [news, setNews] = useState([]);
  const [testimonials, setTestimonials] = useState(TESTIMONIALS);
  const [offices, setOffices] = useState([]);
  const [content, setContent] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [awardsRes, newsRes, testimonialsRes, officesRes, contentRes] = await Promise.allSettled([
          api.get('/cms/awards'),
          api.get('/cms/news'),
          api.get('/cms/testimonials'),
          api.get('/cms/offices'),
          api.get('/cms/content'),
        ]);
        if (awardsRes.status === 'fulfilled' && awardsRes.value.data.length > 0) setAwards(awardsRes.value.data);
        if (newsRes.status === 'fulfilled') setNews(newsRes.value.data);
        if (testimonialsRes.status === 'fulfilled' && testimonialsRes.value.data.length > 0) setTestimonials(testimonialsRes.value.data);
        if (officesRes.status === 'fulfilled') setOffices(officesRes.value.data);
        if (contentRes.status === 'fulfilled') setContent(contentRes.value.data);
      } catch (e) {
        console.error('CMS fetch error:', e);
      }
      setLoaded(true);
    };
    fetchAll();
  }, []);

  const getSiteContent = (key, fallback) => content[key] || fallback;

  const companyInfo = {
    name: getSiteContent('company_name', COMPANY_INFO.name),
    tagline: getSiteContent('company_tagline', COMPANY_INFO.tagline),
    phone: getSiteContent('company_phone', COMPANY_INFO.phone),
    email: getSiteContent('company_email', COMPANY_INFO.email),
    address: getSiteContent('company_address', COMPANY_INFO.address),
    whatsapp: COMPANY_INFO.whatsapp,
    workingHours: COMPANY_INFO.workingHours,
  };

  const heroTitle = getSiteContent('hero_title', 'Where Every Journey Begins with Trust');
  const heroSubtitle = getSiteContent('hero_subtitle', 'From Kerala to the world — three decades of turning travel dreams into boarding passes.');

  return (
    <CMSContext.Provider value={{ awards, news, testimonials, offices, content, companyInfo, heroTitle, heroSubtitle, loaded }}>
      {children}
    </CMSContext.Provider>
  );
}

export function useCMS() {
  const ctx = useContext(CMSContext);
  if (!ctx) throw new Error('useCMS must be used within CMSProvider');
  return ctx;
}
